__webpack_require__.p = "https://static.parastorage.com/services/restaurants-orders-ooi/8a16f04aa0ad718e18ce0ad90e26067293dbd4abb31b15cd253e959a/";